/**
 * FastAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 */
export type CycleStatus =
  | 'null'
  | 'Not Started'
  | 'Setup Incomplete'
  | 'Missing File'
  | 'On Hold'
  | 'In Progress'
  | 'Changes Required'
  | 'Sent For Approval'
  | 'Approved'
  | 'Implemented'
  | 'Approval Required'
  | 'Action Required'
  | 'Scheduled';

export const CycleStatus = {
  Null: 'null' as CycleStatus,
  NotStarted: 'Not Started' as CycleStatus,
  SetupIncomplete: 'Setup Incomplete' as CycleStatus,
  MissingFile: 'Missing File' as CycleStatus,
  OnHold: 'On Hold' as CycleStatus,
  InProgress: 'In Progress' as CycleStatus,
  ChangesRequired: 'Changes Required' as CycleStatus,
  SentForApproval: 'Sent For Approval' as CycleStatus,
  Approved: 'Approved' as CycleStatus,
  ApprovalRequired: 'Approval Required' as CycleStatus,
  Scheduled: 'Scheduled' as CycleStatus,
  Implemented: 'Implemented' as CycleStatus,
  ActionRequired: 'Action Required' as CycleStatus,
} as const;
